window.CollabSeason.ready.then(function(){

(function () {
  if(!document.getElementById('dp'))return;

  var reduce = window.matchMedia(window.CollabSeason.text("sfce63bfb9eba")).matches;
  var member = document.documentElement.classList.contains('member');
  var rtl = document.documentElement.dir === 'rtl';
  var fine = window.matchMedia(window.CollabSeason.text("s19b4d67507d6")).matches;
  var LOCK = window.CollabSeason.text("scaaad0ebc01b_html");
  var DEALS = window.CollabSeason.deals;
  var TODAY = Date.now();
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function byId(id) { for (var i = 0; i < DEALS.length; i++) if (DEALS[i].id === id) return DEALS[i]; return DEALS[0]; }
  function param(k) { var m = new RegExp('[?&]' + k + '=([^&#]*)').exec(location.search); return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : ''; }
  function when(s) { var time = Date.parse(s || ''); return Number.isFinite(time) ? time : Infinity; }
  function soon(d) { return d.by && when(d.by)>=TODAY && when(d.by)-TODAY<=21*864e5; }
  function title(d) { return member ? esc(d.name) : esc(d.hint).replace(/(\S+)$/, window.CollabSeason.text("s96f75bbb726e_html") + LOCK + '</span>'); }
  function plain(d) { return member ? d.name : d.hint; }
  function applyHref(d) { return d.open; }
  function countUp(el, ms) {
    if (reduce || !el) return;
    var txt = el.getAttribute('data-txt') || el.textContent;
    el.setAttribute('data-txt', txt);
    var m = txt.match(/\d[\d,]*/);
    if (!m) return;
    var n = parseInt(m[0].replace(/,/g, ''), 10), t0 = null;
    function step(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / (ms || 800)), e = 1 - Math.pow(1 - k, 3);
      el.textContent = txt.replace(m[0], Math.round(n * e).toLocaleString('en-GB'));
      if (k < 1) requestAnimationFrame(step); else el.textContent = txt;
    }
    requestAnimationFrame(step);
  }
  function rise(el) {
    var w = el.textContent.split(' ');
    el.innerHTML = w.map(function (x, i) { return window.CollabSeason.text("sf6e827661c40_html") + (0.05 + i * 0.06) + 's">' + esc(x) + '</b></span>'; }).join(' ');
  }

  var d = byId(window.CollabSeason.currentCode || param('id') || DEALS[0].id), i = DEALS.indexOf(d);
  var prev = DEALS[(i - 1 + DEALS.length) % DEALS.length], next = DEALS[(i + 1) % DEALS.length];
  // Keep the approved public search title rendered by Shopify.
  var pic = document.getElementById('dpPic');
  pic.style.setProperty('--c', d.c);
  var pop = document.getElementById('dpPop'); pop.src = d.cut;
  var st = document.getElementById('dpSticker'); st.dataset.stickerKind=d.stickerKind;st.innerHTML=window.CollabSeasonStickers.html(d);
  document.getElementById('dpPos').textContent = (i + 1) + window.CollabSeason.text("sa4282e4b2298") + DEALS.length;
  document.getElementById('dpPrev').href = prev.url;
  document.getElementById('dpNext').href = next.url;
  window.CollabSeason.detailLogo(document.getElementById('dpLine'),d);
  document.getElementById('dpLine').textContent = d.line;
  document.getElementById('dpLine').hidden = !d.line;
  document.getElementById('dpTitle').innerHTML = title(d);
  document.getElementById('dpAsk').textContent = d.ask;
  var pay = document.getElementById('dpPay'); pay.textContent = d.pay; setTimeout(function () { countUp(pay, 800); }, 500);
  document.getElementById('dpBy').innerHTML = d.by ? esc(window.CollabSeason.text("s103193d946c4"))+'<bdi dir="auto">'+esc(window.CollabSeason.readerDate(d.by))+'</bdi>' : ''; document.getElementById('dpBy').hidden=!d.by; document.querySelector('.dp-dates').hidden=!d.by;

  var act = document.getElementById('dpAct'), bar = document.getElementById('dpBarText'), barBtn = document.getElementById('dpBarBtn');
  if (member) {
    act.innerHTML = window.CollabSeason.text("sfb26c4e3d3af_html") + applyHref(d) + window.CollabSeason.text("sb56c78314cc0_html") + (window.csSaveHTML ? window.csSaveHTML(d.id, d.name, true) : '');
    bar.innerHTML = '<b>' + esc(d.pay) + '</b><br>' + esc(d.name);
    barBtn.textContent = window.CollabSeason.text("s213445428d84"); barBtn.href = applyHref(d);
  } else {
    act.innerHTML = window.CollabSeason.text("s85f8c4a8c311_html") + LOCK + window.CollabSeason.text("s22a5046f94e9_html") +
      window.CollabSeason.text("sf26eee41eda9_html")+window.CollabSeason.routes.join+window.CollabSeason.text("s9205b2260cbd_html") + (window.CollabSeason.canSave ? window.csSaveHTML(d.id,d.hint,true,true) : '');
    bar.setAttribute('data-deal-price-line','band');bar.hidden=true;
    barBtn.textContent = window.CollabSeason.text("sfd30fe681b4b"); barBtn.href = window.CollabSeason.routes.join;
  }

  function sec(h, inner) { return window.CollabSeason.text("s0b2ed247b68f_html") + h + window.CollabSeason.text("s56c793048810_html") + inner + '</div></section>'; }
  function ticks(list) { return window.CollabSeason.text("s7a6eaeddf8b1_html") + list.map(function (x) { return window.CollabSeason.text("sf1e1affdd630_html") + esc(x) + '</li>'; }).join('') + '</ul>'; }
  function bars(ws) { return window.CollabSeason.text("sd941043c30e0_html") + ws.map(function (w) { return window.CollabSeason.text("s116cec08b447_html") + w + '%"></span>'; }).join('') + '</div>'; }
  var secs = document.getElementById('dpSecs');
  if (member) {
    secs.innerHTML = window.CollabSeason.memberSections(d);
  } else {
    secs.classList.add('locked');
    secs.innerHTML = window.CollabSeason.text("s803cfe6519d8_html") +
      window.CollabSeason.text("s4db7cb832bc3_html")+window.CollabSeason.routes.join+window.CollabSeason.text("s04935589baa2_html") +
      sec(window.CollabSeason.text("sa7417797388d"), bars([82, 64, 48])) + sec(window.CollabSeason.text("sa8fe0ed6088a"), d.countries ? '<p class="deal-source" dir="auto">' + esc(window.CollabSeason.regionLabel(d.countries)) + '</p>' : bars([58])) + sec(window.CollabSeason.text("s41a1acbef296"), bars([74, 40])) +
      sec(window.CollabSeason.text("s5f70b3618a50"), bars([46, 66, 52])) + sec(window.CollabSeason.text("s8d59829c1e15"), bars([60])) + sec(window.CollabSeason.text("sf7fd3fd1454e"), bars([88, 54]));
  }

  var nb = document.getElementById('dpNextBig');
  nb.href = next.url; nb.style.setProperty('--nc', next.c);
  // 437 is an actual brand name, not a leaked row number. Give numeric
  // names their existing public brand kind here so the next card reads clearly.
  document.getElementById('dpNextName').innerHTML = member && /^\d+$/.test(next.name) ? esc(next.name + ' · ' + next.hint.replace(/;\s*/g, ' and ')) : title(next);
  document.getElementById('dpNextPay').textContent = next.pay;

  // the bar at the foot shows once the main button has scrolled away, and steps aside at the footer
  var barEl = document.getElementById('dpBar'), actGone = false, footIn = false;
  function barState() { barEl.classList.toggle('on', actGone && !footIn); }
  new IntersectionObserver(function (es) { actGone = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; barState(); }).observe(act);
  new IntersectionObserver(function (es) { footIn = es[0].isIntersecting; barState(); }).observe(document.querySelector('.foot'));

  // arrows and a swipe on the picture move between opportunities
  document.addEventListener('keydown', function (e) {
    if (e.target.closest && e.target.closest(window.CollabSeason.text("sdb2d5de10af7"))) return;
    if (e.key === window.CollabSeason.text("s8e2f7ffbbdb9")) window.csGo(rtl ? prev.url : next.url);
    if (e.key === window.CollabSeason.text("s48e61e2dd0a2")) window.csGo(rtl ? next.url : prev.url);
  });
  var px = null;
  pic.addEventListener('pointerdown', function (e) { if (!e.target.closest('a')) px = e.clientX; });
  pic.addEventListener('pointerup', function (e) { if (px === null) return; var dx = e.clientX - px; px = null; if (Math.abs(dx) > 50) window.csGo((dx < 0) !== rtl ? next.url : prev.url); });
  var top = document.getElementById('top');
  function onScroll() {
    var y = window.scrollY, max = document.documentElement.scrollHeight - innerHeight;
    top.classList.toggle('line', y > 8);
    top.style.setProperty('--read', max > 0 ? (y / max).toFixed(4) : 0);
  }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  // Each founder-approved visitor sample never renders an apply destination.
  if(!member && window.CollabSeason.sample?.id===d.id){
    var C=window.CollabSeason,n=new Intl.NumberFormat(document.documentElement.lang);
    document.getElementById('dpTitle').textContent=d.name;
    var logo=document.querySelector('#dpInfo [data-card-logo]');
    if(logo){var sampleLogo=document.createElement('span');sampleLogo.className=logo.className;sampleLogo.dataset.sampleLogo=d.id;sampleLogo.append(...logo.childNodes);logo.replaceWith(sampleLogo);}
    var ribbon=document.createElement('p');ribbon.className='sample-ribbon';ribbon.dataset.freeSampleRibbon=d.id;
    ribbon.innerHTML='<span>'+C.escape(C.text('sampleLabel'))+'</span><b>'+C.escape(C.text('sampleAll').replace('__COUNT__',n.format(DEALS.length)))+'</b>';
    document.getElementById('dpLine').before(ribbon);
    act.innerHTML='<a class="btn" href="'+C.escape(C.routes.join)+'">'+C.escape(C.text('sampleJoin'))+'</a>'+(C.canSave?window.csSaveHTML(d.id,d.hint,true,true):'')+'<p class="sample-price" data-price-copy="samplePrice" hidden></p>';
    secs.classList.remove('locked');secs.dataset.freeSampleSections=d.id;
    secs.innerHTML=C.memberSections(d)+'<aside class="sample-end"><p>'+C.escape(C.text('sampleMore').replace('__COUNT__',n.format(Math.max(0,DEALS.length-DEALS.filter(row=>C.freeSampleIds.includes(row.id)).length))))+'</p><a class="btn" data-sample-join-price href="'+C.escape(C.routes.join)+'">'+C.escape(C.text('sfd30fe681b4b'))+'</a></aside>';
    barBtn.textContent=C.text('sampleJoin');
  }

})();

window.CollabSeason.finishPage();
});
